<template>
  <h1>Aqui vai os relatórios de chamadas</h1>
</template>

<script>
export default {

}
</script>

<style>

</style>
